"use strict";

var _objectWithoutProperties = require("/root/icatu-frontend/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _taggedTemplateLiteral = require("/root/icatu-frontend/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  ", "\n  display: flex;\n  height: 100%;\n  align-items: center;\n  pointer-events: none;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  width: 100%;\n  background: transparent;\n  margin: 0;\n  padding: 8px 0 8px 0;\n  border: none;\n  border-bottom: 1px solid ", ";\n  box-sizing: border-box;\n  -webkit-appearance: none;\n  outline: none;\n  ::placeholder {\n    color: ", ";\n  }\n\n  ", ";\n  ", ";\n  ", ";\n\n  &:focus {\n    ", ";\n  }\n\n  &:disabled {\n    ", ";\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  border-color: ", ";\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  border-color: ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  border-color: ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  border-color: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  border-width: 2px;\n  border-color: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  pointer-events: none;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inputIconComponent = exports.flexAdornment = exports.inputDisabled = exports.inputWarning = exports.inputError = exports.inputSuccess = exports.inputFocus = exports.inputBase = exports.inputWrap = void 0;

var _stylitas = require("@creditas/stylitas");

var inputWrap = function inputWrap() {
  return (0, _stylitas.css)(_templateObject());
};

exports.inputWrap = inputWrap;
var inputIconComponent = (0, _stylitas.css)(_templateObject2());
exports.inputIconComponent = inputIconComponent;

var inputFocus = function inputFocus(_ref) {
  var theme = _ref.theme;
  return (0, _stylitas.css)(_templateObject3(), theme.bColorsecondary05);
};

exports.inputFocus = inputFocus;

var inputSuccess = function inputSuccess(_ref2) {
  var theme = _ref2.theme;
  return (0, _stylitas.css)(_templateObject4(), theme.bColorsuccess);
};

exports.inputSuccess = inputSuccess;

var inputError = function inputError(_ref3) {
  var theme = _ref3.theme;
  return (0, _stylitas.css)(_templateObject5(), theme.bColordanger);
};

exports.inputError = inputError;

var inputWarning = function inputWarning(_ref4) {
  var theme = _ref4.theme;
  return (0, _stylitas.css)(_templateObject6(), theme.bColorwarning);
};

exports.inputWarning = inputWarning;

var inputDisabled = function inputDisabled(_ref5) {
  var theme = _ref5.theme;
  return (0, _stylitas.css)(_templateObject7(), theme.bColorneutral05, theme.bColorneutral04);
};

exports.inputDisabled = inputDisabled;

var inputBase = function inputBase(_ref6) {
  var inputPaddingLeft = _ref6.inputPaddingLeft,
      success = _ref6.success,
      error = _ref6.error,
      warning = _ref6.warning,
      props = _objectWithoutProperties(_ref6, ["inputPaddingLeft", "success", "error", "warning"]);

  return (0, _stylitas.css)(_templateObject8(), _stylitas.utilities.typography.paragraph(props.theme), props.theme.bColorneutral05, props.theme.bColorneutral05, success && inputSuccess(props), warning && inputWarning(props), error && inputError(props), inputFocus(props), inputDisabled(props));
};

exports.inputBase = inputBase;

var flexAdornment = function flexAdornment(_ref7) {
  var position = _ref7.position;
  return (0, _stylitas.css)(_templateObject9(), position === 'start' ? 'left:0;' : 'right:0;');
};

exports.flexAdornment = flexAdornment;